import React from "react";
import styled from "styled-components";
import { Plus } from "react-feather";
import { SPOTTER_STRINGS } from "./strings";

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 99px;
  white-space: nowrap;
  font-family: ui-monospace, Menlo, monospace;
  background: var(--spotterOkSoft);
  color: var(--spotterOk);
  border: 1px solid var(--spotterOkLine);
  flex-shrink: 0;
`;

const SpotterNewTag = () => (
  <Tag>
    <Plus size={11} />
    {SPOTTER_STRINGS.newTag}
  </Tag>
);

export default SpotterNewTag;
